var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "200px",
    width: "200px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#ff575f"
    },
    cx: 256,
    cy: 256,
    r: 245.801
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F2F2F2"
    },
    points: "395.561,164.038 347.961,116.44 256,208.401 164.039,116.44 116.439,164.038 208.401,256 116.439,347.962 164.039,395.56 256,303.599 347.961,395.56 395.561,347.962 303.599,256 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4D4D4D"
    },
    d: "M256,512c-68.38,0-132.667-26.628-181.02-74.98S0,324.38,0,256S26.628,123.333,74.98,74.98 S187.62,0,256,0s132.667,26.628,181.02,74.98S512,187.62,512,256s-26.628,132.667-74.98,181.02S324.38,512,256,512z M256,20.398 C126.089,20.398,20.398,126.089,20.398,256S126.089,491.602,256,491.602S491.602,385.911,491.602,256S385.911,20.398,256,20.398z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4D4D4D"
    },
    d: "M347.962,405.759c-2.61,0-5.221-0.996-7.212-2.987L256,318.022l-84.749,84.75 c-3.983,3.982-10.441,3.982-14.425,0l-47.599-47.599c-3.983-3.983-3.983-10.441,0-14.425L193.978,256l-84.75-84.749 c-3.983-3.983-3.983-10.441,0-14.425l47.599-47.599c3.983-3.982,10.441-3.982,14.425,0L256,193.978l84.749-84.75 c3.983-3.982,10.441-3.982,14.425,0l47.599,47.599c3.983,3.983,3.983,10.441,0,14.425L318.022,256l84.75,84.749 c3.983,3.983,3.983,10.441,0,14.425l-47.599,47.599C353.182,404.764,350.572,405.759,347.962,405.759z M256,293.399 c2.61,0,5.221,0.996,7.212,2.987l84.749,84.75l33.175-33.175l-84.75-84.749c-3.983-3.983-3.983-10.441,0-14.425l84.75-84.749 l-33.175-33.175l-84.749,84.75c-3.983,3.982-10.441,3.982-14.425,0l-84.749-84.75l-33.175,33.175l84.75,84.749 c3.983,3.983,3.983,10.441,0,14.425l-84.75,84.749l33.175,33.175l84.749-84.75C250.779,294.396,253.39,293.399,256,293.399z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4D4D4D"
    },
    d: "M454.369,338.616c-1.16,0-2.338-0.199-3.49-0.619c-5.292-1.929-8.02-7.782-6.092-13.074 c9.746-26.753,13.736-55.957,11.539-84.458c-0.433-5.616,3.769-10.519,9.385-10.953c5.622-0.449,10.519,3.769,10.953,9.385 c2.419,31.381-1.977,63.542-12.711,93.008C462.445,336.044,458.534,338.616,454.369,338.616z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4D4D4D"
    },
    d: "M459.567,210.106c-4.479,0-8.586-2.973-9.829-7.502c-0.802-2.917-1.68-5.856-2.613-8.735 c-1.737-5.358,1.199-11.11,6.558-12.847c5.356-1.738,11.11,1.198,12.847,6.558c1.028,3.171,1.997,6.408,2.879,9.623 c1.491,5.432-1.702,11.044-7.135,12.536C461.369,209.987,460.46,210.106,459.567,210.106z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.e0e15bfa4eb17d12e5756326e9cf1cd3.svg";
export { ForwardRef as ReactComponent };